export default "__VITE_ASSET__DRuqEZy7__"